// Projects.js
import React from 'react';
import './Projects.css';

// Sample project data
const projectData = [
{
  id: 1,
  title: 'Generative AI-Powered Real Estate Solution',
  description:
    'A Firebase-based real estate platform that uses Generative AI to power natural language search and real-time property listings, offering a smarter alternative to traditional realtor sites.',
  technologies: [
    'React',
    'Node.js',
    'Firestore',
    'Firebase Functions',
    'Firebase Hosting',
    'Authentication',
    'Gemini API'
  ],
  link: '/projects/ecommerce',
   },
   {
    id: 2,
    title: 'MCP Tool Hub — Central Action Platform',
    description:
      'A central platform using Azure, React, and .NET Core that hosts an MCP server. Various departments (HR, Finance, IT, Ops) expose their tools via MCP so a single assistant can answer questions and perform actions across domains.',
    technologies: [
      'React',
      '.NET Core',
      'Azure',
      'MCP Server',
      'Azure Functions',
      'Azure API Management',
      'Azure Service Bus'
    ],
    link: '/projects/mcp-tool-hub',
  },
  {
  id: 3,
  title: 'AI-Enhanced Blogging Platform',
  description:
    'A modern blogging website built with React and Firebase, featuring secure authentication, real-time content management, and AI-powered writing assistance using the Gemini API.',
  technologies: [
    'React',
    'Node.js',
    'Firestore',
    'Firebase Functions',
    'Firebase Hosting',
    'Authentication',
    'Gemini API'
  ],
  link: '/projects/blog-platform',
},
  // Add more projects as needed
];

const Projects = () => {
  return (
    <div className="projects">
     <h1 className="projects__title">Hobby Projects</h1>
<p className="projects__subtitle">
  End-to-end hobby projects I designed, coded, deployed, and hosted.
</p>

      <div className="projects__list">
        {projectData.map((project) => (
          <div key={project.id} className="projects__card">
            <h3 className="projects__card-title">{project.title}</h3>
            <p className="projects__card-description">{project.description}</p>
            <ul className="projects__technologies">
              {project.technologies.map((tech, index) => (
                <li key={index} className="projects__technology">{tech}</li>
              ))}
            </ul>
            {/* <a href={project.link} className="projects__link">
              View Project
            </a> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
